// Catalogue des services Kiwami Studios & Co
// Chaque service a : slug (URL), clés de traduction, image héro, galerie

export const SERVICES = [
  {
    slug: "btp",
    key: "btp",
    cover:
      "https://images.unsplash.com/photo-1766936587760-fcc13617ca3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3R1cmUlMjBjb25zdHJ1Y3Rpb24lMjBtb2Rlcm58ZW58MHx8fHwxNzc3MDIzNjM4fDA&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1541976590-713941681591?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1487958449943-2429e8be8625?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1590725175785-de025cbe5f87?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1481026469463-66327c86e544?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1600&q=80",
    ],
  },
  {
    slug: "events",
    key: "events",
    cover:
      "https://images.unsplash.com/photo-1764380746258-5954cc8d5fc0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwd2VkZGluZyUyMGV2ZW50fGVufDB8fHx8MTc3NzAyMzYzOXww&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1469371670807-013ccf25f16a?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1527529482837-4698179dc6ce?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1496337589254-7e19d01cec44?auto=format&fit=crop&w=1600&q=80",
    ],
  },
  {
    slug: "sports",
    key: "sports",
    cover:
      "https://images.pexels.com/photos/36983387/pexels-photo-36983387.jpeg",
    gallery: [
      "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1552674605-db6ffd4facb5?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1517649763962-0c623066013b?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1526676037777-05a232554f77?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1530549387789-4c1017266635?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1517438322307-e67111335449?auto=format&fit=crop&w=1600&q=80",
    ],
  },
  {
    slug: "corporate",
    key: "corporate",
    cover:
      "https://images.pexels.com/photos/17582358/pexels-photo-17582358.jpeg",
    gallery: [
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1553484771-371a605b060b?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1552581234-26160f608093?auto=format&fit=crop&w=1600&q=80",
    ],
  },
  {
    slug: "advertising",
    key: "advertising",
    cover:
      "https://images.pexels.com/photos/2820574/pexels-photo-2820574.jpeg",
    gallery: [
      "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1539109136881-3be0616acf4b?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1469334031218-e382a71b716b?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1581404917879-53e19259fdda?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?auto=format&fit=crop&w=1600&q=80",
    ],
  },
  {
    slug: "training",
    key: "training",
    cover:
      "https://images.unsplash.com/photo-1588420490858-3828a17244a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxwaG90b2dyYXBoZXIlMjBzdHVkaW8lMjBjYW1lcmF8ZW58MHx8fHwxNzc3MDIzNjM4fDA&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1452587925148-ce544e77e70d?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1542038784456-1ea8e935640e?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1606986628025-35d57e735ae0?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1554048612-b6a482bc67e5?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1502920917128-1aa500764cbd?auto=format&fit=crop&w=1600&q=80",
    ],
  },
  {
    slug: "phototheque",
    key: "phototheque",
    // Crowd / event scene — illustrates the face-recognition use case
    cover:
      "https://images.pexels.com/photos/1190298/pexels-photo-1190298.jpeg?auto=compress&cs=tinysrgb&w=2400",
    gallery: [
      "https://images.pexels.com/photos/2747449/pexels-photo-2747449.jpeg?auto=compress&cs=tinysrgb&w=1600",
      "https://images.pexels.com/photos/1190298/pexels-photo-1190298.jpeg?auto=compress&cs=tinysrgb&w=1600",
      "https://images.pexels.com/photos/1763075/pexels-photo-1763075.jpeg?auto=compress&cs=tinysrgb&w=1600",
      "https://images.pexels.com/photos/2014775/pexels-photo-2014775.jpeg?auto=compress&cs=tinysrgb&w=1600",
      "https://images.pexels.com/photos/1763067/pexels-photo-1763067.jpeg?auto=compress&cs=tinysrgb&w=1600",
      "https://images.pexels.com/photos/2747448/pexels-photo-2747448.jpeg?auto=compress&cs=tinysrgb&w=1600",
    ],
    // Live embedded gallery (Geosnapshot face-recognition portal).
    // ServiceDetail.jsx renders the iframe inline when this URL is present.
    embed_url:
      "https://geosnapshot.com/org/kiwami-studios-co?embed=true&source=org-gallery-embed",
  },
];

export const getServiceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);

// Formations proposées
export const COURSES = [
  {
    key: "essentials",
    duration_fr: "2 jours",
    duration_en: "2 days",
    price: "1 800 MAD",
    level_fr: "Débutant",
    level_en: "Beginner",
  },
  {
    key: "portrait",
    duration_fr: "3 jours",
    duration_en: "3 days",
    price: "3 200 MAD",
    level_fr: "Intermédiaire",
    level_en: "Intermediate",
  },
  {
    key: "advanced",
    duration_fr: "5 jours",
    duration_en: "5 days",
    price: "6 500 MAD",
    level_fr: "Avancé",
    level_en: "Advanced",
  },
];
